export default __webpack_public_path__ + "images/classified_instruction_2-L4cww.png";